export type WidgetIconName = 'bar' | 'up' | 'down' | 'star';

const ICON_PATHS: Record<WidgetIconName, string> = {
  bar: 'M3 21h18v-2H3v2zM5 17h2V7H5v10zm6 0h2V3h-2v14zm6 0h2v-7h-2v7z',
  down: 'M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6h-6z',
  star: 'M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4-6.2-4.6-6.2 4.6 2.4-7.4L2 9.4h7.6L12 2z',
  up: 'M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z',
};

export const WidgetIcon = ({ name }: { name: WidgetIconName }) => (
  <span className="flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-[9px] bg-[#eaf0fb]">
    <svg className="h-[17px] w-[17px] fill-[#3f6df6]" viewBox="0 0 24 24">
      <path d={ICON_PATHS[name]} />
    </svg>
  </span>
);
